var $7iAsj$react = require("react");
var $7iAsj$muiiconsmaterialMoreHoriz = require("@mui/icons-material/MoreHoriz");
var $7iAsj$reactjsxruntime = require("react/jsx-runtime");
var $7iAsj$styledcomponents = require("styled-components");
var $7iAsj$muimaterialIconButton = require("@mui/material/IconButton");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DropdownMenu", {
    enumerable: true,
    get: function get() {
        return $4b8c1e65f805ba0f$exports.DropdownMenu;
    }
});
Object.defineProperty(module.exports, "MenuItem", {
    enumerable: true,
    get: function get() {
        return $baebdd1af89d0050$exports.MenuItem;
    }
});
var $4b8c1e65f805ba0f$exports = {};
"use strict";
function $4b8c1e65f805ba0f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4b8c1e65f805ba0f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4b8c1e65f805ba0f$var$_typeof(o);
}
Object.defineProperty($4b8c1e65f805ba0f$exports, "__esModule", {
    value: true
});
$4b8c1e65f805ba0f$exports.DropdownMenu = void 0;

var $4b8c1e65f805ba0f$var$_react = $4b8c1e65f805ba0f$var$_interopRequireWildcard($7iAsj$react);

var $4b8c1e65f805ba0f$var$_MoreHoriz = $4b8c1e65f805ba0f$var$_interopRequireDefault($7iAsj$muiiconsmaterialMoreHoriz);
var $baebdd1af89d0050$exports = {};
"use strict";
Object.defineProperty($baebdd1af89d0050$exports, "__esModule", {
    value: true
});
$baebdd1af89d0050$exports.Wrapper = $baebdd1af89d0050$exports.StyledIconButton = $baebdd1af89d0050$exports.MenuWrapper = $baebdd1af89d0050$exports.MenuItem = $baebdd1af89d0050$exports.MenuBoxWrapper = $baebdd1af89d0050$exports.MenuBox = $baebdd1af89d0050$exports.Backdrop = void 0;

var $baebdd1af89d0050$var$_styledComponents = $baebdd1af89d0050$var$_interopRequireDefault($7iAsj$styledcomponents);

var $baebdd1af89d0050$var$_IconButton = $baebdd1af89d0050$var$_interopRequireDefault($7iAsj$muimaterialIconButton);
var $baebdd1af89d0050$var$_templateObject, $baebdd1af89d0050$var$_templateObject2, $baebdd1af89d0050$var$_templateObject3, $baebdd1af89d0050$var$_templateObject4, $baebdd1af89d0050$var$_templateObject5, $baebdd1af89d0050$var$_templateObject6, $baebdd1af89d0050$var$_templateObject7;
function $baebdd1af89d0050$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $baebdd1af89d0050$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $baebdd1af89d0050$var$Wrapper = $baebdd1af89d0050$exports.Wrapper = $baebdd1af89d0050$var$_styledComponents["default"].div($baebdd1af89d0050$var$_templateObject || ($baebdd1af89d0050$var$_templateObject = $baebdd1af89d0050$var$_taggedTemplateLiteral([
    "\n  position: relative;\n  display: inline-block;\n"
])));
var $baebdd1af89d0050$var$StyledIconButton = $baebdd1af89d0050$exports.StyledIconButton = (0, $baebdd1af89d0050$var$_styledComponents["default"])($baebdd1af89d0050$var$_IconButton["default"]).attrs(function() {
    return {
        classes: {
            root: "root"
        }
    };
})($baebdd1af89d0050$var$_templateObject2 || ($baebdd1af89d0050$var$_templateObject2 = $baebdd1af89d0050$var$_taggedTemplateLiteral([
    "\n  &.root {\n    padding: 0;\n\n    &:focus {\n      box-shadow: none;\n    }\n  }\n"
])));
var $baebdd1af89d0050$var$Backdrop = $baebdd1af89d0050$exports.Backdrop = $baebdd1af89d0050$var$_styledComponents["default"].div($baebdd1af89d0050$var$_templateObject3 || ($baebdd1af89d0050$var$_templateObject3 = $baebdd1af89d0050$var$_taggedTemplateLiteral([
    "\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: fixed;\n  z-index: 1;\n"
])));
var $baebdd1af89d0050$var$MenuWrapper = $baebdd1af89d0050$exports.MenuWrapper = $baebdd1af89d0050$var$_styledComponents["default"].div($baebdd1af89d0050$var$_templateObject4 || ($baebdd1af89d0050$var$_templateObject4 = $baebdd1af89d0050$var$_taggedTemplateLiteral([
    "\n  opacity: ",
    ";\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n  visibility: ",
    ";\n"
])), function(props) {
    return props.isOpen ? 1 : 0;
}, function(props) {
    return props.isOpen ? "visible" : "hidden";
});
var $baebdd1af89d0050$var$arrowSize = 10;
var $baebdd1af89d0050$var$arrowDistanceToBorder = 6;
var $baebdd1af89d0050$var$MenuBoxWrapper = $baebdd1af89d0050$exports.MenuBoxWrapper = $baebdd1af89d0050$var$_styledComponents["default"].div($baebdd1af89d0050$var$_templateObject5 || ($baebdd1af89d0050$var$_templateObject5 = $baebdd1af89d0050$var$_taggedTemplateLiteral([
    "\n  border-radius: 4px;\n  overflow: hidden;\n"
])));
var $baebdd1af89d0050$var$MenuBox = $baebdd1af89d0050$exports.MenuBox = $baebdd1af89d0050$var$_styledComponents["default"].div($baebdd1af89d0050$var$_templateObject6 || ($baebdd1af89d0050$var$_templateObject6 = $baebdd1af89d0050$var$_taggedTemplateLiteral([
    "\n  top: 100%;\n  margin-top: 10px;\n  position: absolute;\n  border-radius: 4px;\n  background-color: ",
    ";\n  transition: height 0.3s ease;\n  ",
    ";\n  z-index: ",
    ";\n  border: 1px solid ",
    ";\n\n  &.left {\n    left: 50%;\n    margin-left: -",
    "px;\n  }\n\n  &.right {\n    right: 50%;\n    margin-right: -",
    "px;\n  }\n\n  :after,\n  :before {\n    bottom: 100%;\n    border: solid transparent;\n    content: ' ';\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  :after {\n    border-width: ",
    "px;\n  }\n\n  :before {\n    border-width: ",
    "px;\n  }\n\n  &.left:after,\n  &.left:before {\n    left: ",
    "px;\n  }\n\n  &.right:after,\n  &.right:before {\n    right: ",
    "px;\n  }\n\n  &.left:after {\n    border-bottom-color: ",
    ";\n    margin-left: ",
    "px;\n  }\n\n  &.left:before {\n    border-bottom-color: ",
    ";\n    margin-left: ",
    "px;\n  }\n\n  &.right:after {\n    border-bottom-color: ",
    ";\n    margin-right: ",
    "px;\n  }\n\n  &.right:before {\n    border-bottom-color: ",
    ";\n    margin-right: ",
    "px;\n  }\n"
])), function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.boxShadow.level4;
}, function(props) {
    return props.theme.layer.popup;
}, function(props) {
    return props.theme.color.g300;
}, $baebdd1af89d0050$var$arrowSize + $baebdd1af89d0050$var$arrowDistanceToBorder, $baebdd1af89d0050$var$arrowSize + $baebdd1af89d0050$var$arrowDistanceToBorder, $baebdd1af89d0050$var$arrowSize, $baebdd1af89d0050$var$arrowSize + 1, $baebdd1af89d0050$var$arrowSize + $baebdd1af89d0050$var$arrowDistanceToBorder, $baebdd1af89d0050$var$arrowSize + $baebdd1af89d0050$var$arrowDistanceToBorder, function(props) {
    return props.theme.color.white;
}, -$baebdd1af89d0050$var$arrowSize, function(props) {
    return props.theme.color.g300;
}, -$baebdd1af89d0050$var$arrowSize - 1, function(props) {
    return props.theme.color.white;
}, -$baebdd1af89d0050$var$arrowSize, function(props) {
    return props.theme.color.g300;
}, -$baebdd1af89d0050$var$arrowSize - 1);
var $baebdd1af89d0050$var$MenuItem = $baebdd1af89d0050$exports.MenuItem = $baebdd1af89d0050$var$_styledComponents["default"].div($baebdd1af89d0050$var$_templateObject7 || ($baebdd1af89d0050$var$_templateObject7 = $baebdd1af89d0050$var$_taggedTemplateLiteral([
    "\n  cursor: pointer;\n  ",
    ";\n  padding: 10px 6px;\n  white-space: nowrap;\n  border-style: solid;\n  border-width: 1px 0;\n  border-bottom-width: 0;\n  ",
    ";\n  color: ",
    ";\n  border-color: ",
    ";\n\n  &:hover {\n    background: ",
    ";\n  }\n\n  &:first-child {\n    border-top-width: 0;\n  }\n"
])), function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.color.black;
}, function(props) {
    return props.theme.color.g300;
}, function(props) {
    return props.theme.color.g100;
});



var $4b8c1e65f805ba0f$var$_excluded = [
    "menuButton",
    "children",
    "alignment",
    "classes",
    "defaultIsOpen",
    "menuButtonProps"
];
var $4b8c1e65f805ba0f$var$_MoreHorizIcon;
function $4b8c1e65f805ba0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4b8c1e65f805ba0f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4b8c1e65f805ba0f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4b8c1e65f805ba0f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $4b8c1e65f805ba0f$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $4b8c1e65f805ba0f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4b8c1e65f805ba0f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4b8c1e65f805ba0f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4b8c1e65f805ba0f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4b8c1e65f805ba0f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4b8c1e65f805ba0f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4b8c1e65f805ba0f$var$_defineProperty(e, r, t) {
    return (r = $4b8c1e65f805ba0f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4b8c1e65f805ba0f$var$_toPropertyKey(t) {
    var i = $4b8c1e65f805ba0f$var$_toPrimitive(t, "string");
    return "symbol" == $4b8c1e65f805ba0f$var$_typeof(i) ? i : i + "";
}
function $4b8c1e65f805ba0f$var$_toPrimitive(t, r) {
    if ("object" != $4b8c1e65f805ba0f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4b8c1e65f805ba0f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4b8c1e65f805ba0f$var$_slicedToArray(r, e) {
    return $4b8c1e65f805ba0f$var$_arrayWithHoles(r) || $4b8c1e65f805ba0f$var$_iterableToArrayLimit(r, e) || $4b8c1e65f805ba0f$var$_unsupportedIterableToArray(r, e) || $4b8c1e65f805ba0f$var$_nonIterableRest();
}
function $4b8c1e65f805ba0f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4b8c1e65f805ba0f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4b8c1e65f805ba0f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4b8c1e65f805ba0f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4b8c1e65f805ba0f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $4b8c1e65f805ba0f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4b8c1e65f805ba0f$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $4b8c1e65f805ba0f$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4b8c1e65f805ba0f$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $4b8c1e65f805ba0f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4b8c1e65f805ba0f$var$DefaultMenuBtn = function DefaultMenuBtn(_ref) {
    var onClick = _ref.onClick;
    return /*#__PURE__*/ (0, $7iAsj$reactjsxruntime.jsx)($baebdd1af89d0050$exports.StyledIconButton, {
        onClick: onClick,
        children: $4b8c1e65f805ba0f$var$_MoreHorizIcon || ($4b8c1e65f805ba0f$var$_MoreHorizIcon = /*#__PURE__*/ (0, $7iAsj$reactjsxruntime.jsx)($4b8c1e65f805ba0f$var$_MoreHoriz["default"], {}))
    });
};
var $4b8c1e65f805ba0f$var$handleMenuBtnClick = function handleMenuBtnClick(setIsOpen, isOpen) {
    return function() {
        setIsOpen(isOpen);
    };
};
var $4b8c1e65f805ba0f$var$DropdownMenu = $4b8c1e65f805ba0f$exports.DropdownMenu = function DropdownMenu(props) {
    var _props$menuButton = props.menuButton, MenuButton = _props$menuButton === void 0 ? $4b8c1e65f805ba0f$var$DefaultMenuBtn : _props$menuButton, children = props.children, _props$alignment = props.alignment, alignment = _props$alignment === void 0 ? "left" : _props$alignment, _props$classes = props.classes, classes = _props$classes === void 0 ? {
        menuWrapper: ""
    } : _props$classes, _props$defaultIsOpen = props.defaultIsOpen, defaultIsOpen = _props$defaultIsOpen === void 0 ? false : _props$defaultIsOpen, _props$menuButtonProp = props.menuButtonProps, menuButtonProps = _props$menuButtonProp === void 0 ? {} : _props$menuButtonProp, menuOptionProps = $4b8c1e65f805ba0f$var$_objectWithoutProperties(props, $4b8c1e65f805ba0f$var$_excluded);
    var _useState = (0, $4b8c1e65f805ba0f$var$_react.useState)(Boolean(defaultIsOpen)), _useState2 = $4b8c1e65f805ba0f$var$_slicedToArray(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    return /*#__PURE__*/ (0, $7iAsj$reactjsxruntime.jsxs)($baebdd1af89d0050$exports.Wrapper, $4b8c1e65f805ba0f$var$_objectSpread($4b8c1e65f805ba0f$var$_objectSpread({}, menuOptionProps), {}, {
        onClick: function onClick(event) {
            event.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0, $7iAsj$reactjsxruntime.jsx)(MenuButton, $4b8c1e65f805ba0f$var$_objectSpread($4b8c1e65f805ba0f$var$_objectSpread({}, menuButtonProps), {}, {
                onClick: $4b8c1e65f805ba0f$var$handleMenuBtnClick(setIsOpen, true),
                isOpen: isOpen
            })),
            /*#__PURE__*/ (0, $7iAsj$reactjsxruntime.jsxs)($baebdd1af89d0050$exports.MenuWrapper, {
                isOpen: isOpen,
                className: [
                    alignment,
                    classes.menuWrapper
                ].join(" ").trim(),
                children: [
                    /*#__PURE__*/ (0, $7iAsj$reactjsxruntime.jsx)($baebdd1af89d0050$exports.Backdrop, {
                        "data-testid": "backdrop",
                        onClick: $4b8c1e65f805ba0f$var$handleMenuBtnClick(setIsOpen, false)
                    }),
                    /*#__PURE__*/ (0, $7iAsj$reactjsxruntime.jsx)($baebdd1af89d0050$exports.MenuBox, {
                        className: alignment,
                        role: "menu",
                        children: /*#__PURE__*/ (0, $7iAsj$reactjsxruntime.jsx)($baebdd1af89d0050$exports.MenuBoxWrapper, {
                            children: $4b8c1e65f805ba0f$var$_react["default"].Children.toArray(children).filter(function(c) {
                                return c;
                            }).map(function(child) {
                                return /*#__PURE__*/ $4b8c1e65f805ba0f$var$_react["default"].isValidElement(child) && /*#__PURE__*/ $4b8c1e65f805ba0f$var$_react["default"].cloneElement(child, $4b8c1e65f805ba0f$var$_objectSpread($4b8c1e65f805ba0f$var$_objectSpread({}, child.props), {}, {
                                    onClick: function onClick(e) {
                                        var _child$props$onClick, _child$props;
                                        $4b8c1e65f805ba0f$var$handleMenuBtnClick(setIsOpen, false)();
                                        (_child$props$onClick = (_child$props = child.props).onClick) === null || _child$props$onClick === void 0 || _child$props$onClick.call(_child$props, e);
                                    }
                                }));
                            })
                        })
                    })
                ]
            })
        ]
    }));
};





//# sourceMappingURL=index.js.map
